import { useEffect } from "react";
import {  useLocation } from "react-router-dom";

const Fix = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.jQuery && window.elementorFrontend) {
      window.elementorFrontend.init();
    }
    document.querySelectorAll("img").forEach((img) => {
      img.src = img.src;
    });

    setTimeout(() => {
      window.dispatchEvent(new Event("scroll"));
    }, 500);
  }, [location.pathname]);

  return null;
};

export default Fix;
